import { ReactNode } from "react";
import classNames from "classnames";
import style from "./UnconnectedPageTemplate.module.scss";

export interface UnconnectedPageTemplateProps {
  children: ReactNode;
  className?: string;
}

export function UnconnectedPageTemplate({
  children,
  className,
}: UnconnectedPageTemplateProps) {
  return <div className={classNames(style.root, className)}>{children}</div>;
}
